export default __webpack_public_path__ + "static/media/BoilingImg.5777381d.jpg";